module.exports = "<p>\n  notificacao-dialog works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/notificacao/notificacao-dialog/notificacao-dialog.component.html
// module id = ../../../../../src/app/components/notificacao/notificacao-dialog/notificacao-dialog.component.html
// module chunks = main